import { render, staticRenderFns } from "./IconLocal.vue?vue&type=template&id=2e46a695&"
import script from "./IconLocal.vue?vue&type=script&lang=js&"
export * from "./IconLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e46a695')) {
      api.createRecord('2e46a695', component.options)
    } else {
      api.reload('2e46a695', component.options)
    }
    module.hot.accept("./IconLocal.vue?vue&type=template&id=2e46a695&", function () {
      api.rerender('2e46a695', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconLocal.vue"
export default component.exports